import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Location } from 'src/app/models/Reports'

@Component({
	selector: 'app-location',
	templateUrl: './location.component.html'
})
export class LocationComponent implements OnInit {
	@Input() public location: Location = new Location()
	@Input() public isNotFoundTree: boolean = false
	@Input() public appraisalId: string = ''
	@Input() public treeImage: string = ''
	@Input() public requester: string = ''
	@Input() public disabled: boolean = true

	@Output() public updateRequester = new EventEmitter()
	@Output() public addressModified = new EventEmitter()

	public mapLocation: google.maps.Map
	public marker: google.maps.Marker

	public ngOnInit() {
		setTimeout(() => {
			this.initMap()
		}, 500)
	}

	public initMap() {
		const mapView: HTMLDivElement = document.getElementById(
			`tree-location${this.appraisalId}`
		) as HTMLDivElement

		const lat: number = this.location.lat
		const lng: number = this.location.lng

		const position = new google.maps.LatLng(lat, lng)

		const map: google.maps.Map = new google.maps.Map(mapView, {
			zoom: 18,
			center: position,
			gestureHandling: 'cooperative'
		})

		map.setOptions({
			styles: [
				{
					featureType: 'poi',
					stylers: [{ visibility: 'off' }]
				},
				{
					featureType: 'transit.station.bus',
					stylers: [{ visibility: 'off' }]
				}
			],
			disableDefaultUI: true,
			draggable: false,
			zoomControl: false,
			scrollwheel: false,
			disableDoubleClickZoom: true,
			fullscreenControl: false,
			streetViewControl: false
		})

		this.mapLocation = map

		const svg = {
			path: 'M103 145 c-72 -50 -6 -169 76 -135 77 32 54 150 -29 150 -14 0 -35 -7 -47 -15z',
			fillColor: '#006636',
			fillOpacity: 1,
			scale: 0.095,
			strokeWeight: 0
		}

		this.marker = new google.maps.Marker({
			position,
			icon: svg,
			map,
			draggable: false
		})
	}

	public openUpdateRequester() {
		this.updateRequester.emit(this.appraisalId)
	}

	public addressWasChanged() {
		this.addressModified.emit()
	}
}
